import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchEventsByOrg, fetchEventByCode } from "../Api/ViewEvent";
import { Container, Table, Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";

const ViewEvent = () => {
  const navigate = useNavigate();
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const orgId = userDetails?.organisationId;

  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    loadEvents();
  }, []);

  const loadEvents = async () => {
    try {
      const data = await fetchEventsByOrg(orgId);

      setEvents(data);
    } catch (error) {
      toast.error("Error fetching events");
    }
  };

  const handleView = async (eventCode) => {
    try {
      const data = await fetchEventByCode(orgId, eventCode);

      setSelectedEvent(data);
      setShowModal(true);
    } catch (error) {
      toast.error("Error fetching event details");
    }
  };

  return (
    <div className="main-content expand">
      <Container fluid className="list-container">
        <h4 className="mb-3">Event List</h4>

        {events.length > 0 ? (
          <Table bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Event Code</th>
                <th>Event Name</th>
                <th>Type</th>
                <th>Date</th>
                <th>End Date</th>
                <th>Location</th>
                <th>Organizer</th>
                <th>Department</th>
                <th>Status</th>
                <th
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Action
                </th>
              </tr>
            </thead>

            <tbody>
              {events.map((event, index) => (
                <tr key={event.eventCode}>
                  <td>{index + 1}</td>

                  <td>{event.eventCode}</td>

                  <td>{event.eventName}</td>

                  <td>{event.eventType}</td>

                  <td>{moment(event.eventDate).format("DD-MM-YYYY")}</td>

                  <td>
                    {event.eventEndDate
                      ? moment(event.eventEndDate).format("DD-MM-YYYY")
                      : "-"}
                  </td>

                  <td>{event.eventLocation}</td>

                  <td>{event.organizerName}</td>

                  <td>{event.department}</td>

                  <td>{event.eventStatus}</td>

                  <td
                    style={{
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      size="sm"
                      variant="info"
                      onClick={() => handleView(event.eventCode)}
                    >
                      View
                    </Button>

                    <Button
                      size="sm"
                      variant="warning"
                      className="ms-2"
                      onClick={() => navigate(`/editEvent/${event.eventCode}`)}
                    >
                      Edit
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <p>No events found</p>
        )}

        {/* EVENT DETAILS MODAL */}

        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Event Details</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {selectedEvent && (
              <div>
                <p>
                  <b>Event Code:</b> {selectedEvent.eventCode}
                </p>
                <p>
                  <b>Event Name:</b> {selectedEvent.eventName}
                </p>
                <p>
                  <b>Type:</b> {selectedEvent.eventType}
                </p>
                <p>
                  <b>Description:</b> {selectedEvent.eventDescription}
                </p>
                <p>
                  <b>Location:</b> {selectedEvent.eventLocation}
                </p>
                <p>
                  <b>Organizer:</b> {selectedEvent.organizerName}
                </p>
                <p>
                  <b>Department:</b> {selectedEvent.department}
                </p>
                <p>
                  <b>Status:</b> {selectedEvent.eventStatus}
                </p>
              </div>
            )}
          </Modal.Body>
        </Modal>
      </Container>
    </div>
  );
};

export default ViewEvent;
